import React from "react";
import { WHATSAPP_URL } from "./WhatsAppFloat";

export const Footer = () => {
  return (
    <footer className="border-t mt-32" style={{ borderColor: "#DEDAE2", background: "#FAF9FB" }}>
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <div className="w-6 h-6 rounded-md" style={{ background: "#7228C8" }} />
              <span className="font-extrabold text-[17px] tracking-hero" style={{ color: "#1E1924" }}>
                We<span style={{ color: "#7228C8" }}>·</span>Spik
              </span>
            </div>
            <p className="text-[14px] leading-[1.6] max-w-prose-tight" style={{ color: "#70667A" }}>
              We<span style={{ color: "#7228C8" }}>·</span>Spik · Clases de conversación con nativos y tu pronunciación, medida.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener"
              className="inline-block mt-3 text-[14px] underline hover:text-[#1E1924]"
              style={{ color: "#141018" }}
              data-testid="footer-whatsapp-link"
            >
              Escríbenos por WhatsApp para más información
            </a>
            <p className="text-[12px] mt-6" style={{ color: "#70667A" }}>
              © {new Date().getFullYear()} We<span style={{ color: "#7228C8" }}>·</span>Spik · Hecho en España · <a href="mailto:toni@wer2ecosystem.com" className="underline hover:text-[#1E1924]">toni@wer2ecosystem.com</a>
            </p>
          </div>
          <div>
            <div className="wk-eyebrow mb-4">Producto</div>
            <ul className="space-y-2 text-[14px]" style={{ color: "#1E1924" }}>
              <li><a href="/tutores" className="hover:underline">Ver tutores</a></li>
              <li><a href="/reservar" className="hover:underline">Reservar sesión · $22</a></li>
              <li><a href="/privacidad" className="hover:underline">Privacidad</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};
